<p-toast position="bottom-right"></p-toast>
<p-blockUI [blocked]="blockUI"></p-blockUI>
<div class="card m-1">
  <p-breadcrumb [model]="items"></p-breadcrumb>
</div>
<div class="card m-1">

  <div class="card-header bg-gradient-gray-dark text-orange">
    <i class="nav-icon fas fa-chart-line mr-1"></i>
    <strong> Graphs  {{lineName}}</strong>

  </div>
  <div class="card-body">

    <br />
    <div class="row" *ngIf="!notExist" >
      <div class="col-12" id="chartContainer">

      </div>
    </div>


    <div class="row">
      <img *ngIf="notExist" src="../../../../assets/error404.jpg" />
    </div>

    </div>

  </div>

<p-dialog [modal]="true" *ngIf="showGraph" id="graph-container" [(visible)]="showGraph" [style]="{width: '70vw',color:'darkorange' }" append="body">
  <ng-template pTemplate="header">
    <span>{{currentSelectedGraph.graphName}}</span>
  </ng-template>
  <app-single-graph [graphName]="currentSelectedGraph.graphName" [readingList]="readingList" [interfacesIds]="currentSelectedGraph.interfaceId"></app-single-graph>

</p-dialog>

